import script from "./DialogReservoir.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogReservoir.vue?vue&type=script&setup=true&lang=ts"

import "./DialogReservoir.vue?vue&type=style&index=0&id=2aa44518&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa44518"]])

export default __exports__